export default {
  /**
   * Mixin for handling route permissions in navigation components.
   * Provides methods for checking route permissions and initializes route access.
   */
  computed: {
    routeMap() {
      const map = new Map();
      this.$router.options.routes.forEach(route => {
        if (route.name) {
          map.set(route.name, route);
        }
      });
      return map;
    },
  },
  created() {
    this.initializeRoutePermissions();
  },
  methods: {
    initializeRoutePermissions() {
      const allRoutes = this.$router.options.routes;

      this.routes.forEach((route) => {
        if (!route.route) {
          return;
        }

        const foundRoute = allRoutes.find(r => r.name === route.route.name);

        // Disable the route (show it)
        if (!foundRoute) {
          route.disabled = true;
          route.access = true;
          return;
        }

        const { meta } = foundRoute;

        if (!meta || !meta.permissions) {
          route.access = true;
          return;
        }

        // currently AND only
        let access = false;
        meta.permissions.forEach((p) => {
          access = this.$can(p.action, p.subject);
        });

        route.access = access;
      });
    },
    hasPermissionToRoute(route) {
      if (!route || !route.route || !route.route.name) {
        return false;
      }

      const foundRoute = this.routeMap.get(route.route.name);

      if (!foundRoute || !foundRoute.meta || !foundRoute.meta.permissions) {
        return true;
      }

      return foundRoute.meta.permissions.some(p => this.$can(p.action, p.subject));
    },
  },
};
